import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export { default as Button } from './Button.vue';

export const buttonVariants = cva(
    "inline-flex items-center max-w-full justify-center gap-2 rounded-md text-sm font-semibold transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive cursor-pointer",
    {
        variants: {
            variant: {
                default:
                    'bg-primary text-primary-foreground hover:bg-primary-hover disabled:bg-primary-disabled disabled:opacity-100',
                destructive:
                    'border-1 border-destructive-border bg-transparent text-destructive hover:text-white hover:bg-destructive-hover focus-visible:ring-error',
                outline:
                    'border border-border-3 bg-outline hover:bg-outline-hover hover:text-foreground',
                secondary:
                    'bg-secondary text-secondary-foreground hover:bg-secondary/60',
                ghost: 'bg-ghost hover:bg-ghost-hover text-foreground data-[state=open]:bg-ghost-hover',
                link: 'text-foreground link-hover !p-0 !h-auto [&_svg:last-child]:-ml-1',
            },
            size: {
                default: 'min-h-9 px-4 py-2 has-[>svg]:px-3',
                xs: 'min-h-6 rounded px-2 py-0.5',
                sm: 'min-h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5 py-0.5',
                lg: 'min-h-10 rounded-md px-6 has-[>svg]:px-4 py-1.5',
                icon: 'size-9',
                'icon-sm': 'size-8',
                'icon-lg': 'size-10',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
        },
    }
);
export type ButtonVariants = VariantProps<typeof buttonVariants>;
